var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-message" }, [
    _c("img", { attrs: { src: "/static/img/empty-filter-result.png" } }),
    _vm._v(" "),
    _c("div", [_vm.Title ? _c("h2", [_vm._v(_vm._s(_vm.Title))]) : _vm._e()]),
    _vm._v(" "),
    _vm.Desc ? _c("div", [_vm._v(_vm._s(_vm.Desc))]) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }